(function () {
  'use strict';

  var redeemSelector = '.new-auth-reward-redeem';
  var discountUrl = '/cart?coupon=MULE%405';

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target.closest(redeemSelector) : null;
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.location.assign(discountUrl);
    },
    true
  );
})();